// extracted by mini-css-extract-plugin
export var active = "_bx-7";
export var container = "_bx-0";
export var evenWidth = "_bx-4";
export var large = "_bx-5";
export var outlet = "_bx-8";
export var slide = "_bx-2";
export var small = "_bx-6";
export var tab = "_bx-3";
export var tabs = "_bx-1";